export enum AccidentOptions {
	ACCIDENT_FREE = "ACCIDENT_FREE",
	NOT_ACCIDENT_FREE = "NOT_ACCIDENT_FREE",
}

export const isAccidentFree = (option: AccidentOptions): boolean => option === AccidentOptions.ACCIDENT_FREE

export const toAccidentOptions = (accidentFree: boolean): AccidentOptions =>
	accidentFree ? AccidentOptions.ACCIDENT_FREE : AccidentOptions.NOT_ACCIDENT_FREE
